module directives {
    export module tariff {
        interface ITarrifDetailScope extends ng.IScope {    
            showTarifDetail();
            nationalMeasureCode: string;
            dutyTypeCode : string;
            dutyTypeId: number;
            countryId: number;
            simulationDate: moment.Moment;
            isTarrifSearch: boolean;
        }

        export class tariffDetailDirective implements ng.IDirective {
            template = `
                    <div class="GridButton">
                        <center>
                            <button type="button" class="btn btn-default btn-sm" ng-click="showTarifDetail()">
                                <span class="fa fa-eye"></span>
                            </button>
                        </center>
                    </div>
                   `;
            scope = {              
                nationalMeasureCode: "=",
                dutyTypeCode: "=",
                dutyTypeId: "=",
                countryId: "=",
                simulationDate: "=",
                isTarrifSearch: "="
            }

            messages: interfaces.applicationcore.IMessage[];

            constructor(
                private generalService: interfaces.applicationcore.IGeneralService,
                public $uibModal: ng.ui.bootstrap.IModalService,
                private hsCodeService: interfaces.tariff.IHsCodeService,
                private $state: ng.ui.IStateService,
                private bsLoadingOverlayService,
                private menuService: interfaces.applicationcore.IMenuService,
                private wcoTradeToolsService: interfaces.tariff.IWCOTradeToolsService,
                private $q: ng.IQService,
            ) {
            }

            link = ($scope: ITarrifDetailScope, $element: ng.IAugmentedJQuery, $state) => {
                $scope.showTarifDetail = () => {
                    this.showTariffDetail($scope.nationalMeasureCode,
                        $scope.dutyTypeCode,
                        $scope.dutyTypeId,
                        $scope.countryId,
                        $scope.simulationDate,
                        $scope.isTarrifSearch);
                };
            }

            showTariffDetail(nationalMeasureCode: string, dutyTypeCode: string, dutyTypeId: number, countryId: number, simulationDate: moment.Moment, isTarrifSearch: boolean) {
                    this.$uibModal.open({
                        animation: true,
                        template: `
                        <div class="modal-content">
                            <div bs-loading-overlay bs-loading-overlay-reference-id="tariffLoading">
	                            <div class="modal-header">
                                    <div class="row vertical-align">
                                        <div class="col-md-4">
                                            <h3 class="modal-title" id="modal-title">Commodity Code {{nationalMeasureCode}} ({{Type}})</h3>
                                        </div>
                                        <div class="col-md-7">
                                            <h3 class="modal-title">{{tariffDetail.CountryCode}} - {{tariffDetail.CountryDescription}}</h3>
                                        </div>
                                        <div class="col-md-1">
                                            <button type="button" class="btn btn-default btn-sm" ng-click="getDetailPDF()">
                                                <span class="fa fa-file-pdf-o" style="color: #cb0606; font-size:22px"></span>
                                            </button>
                                        </div>
                                    </div>
	                            </div>
                                <div class="modal-body" id="modal-body">
                                    <div class="row" ng-if="dutyTypeId !== 163">
                                        <div class="col-md-12">
                                            <div class="row vertical-align">
                                                <div class="col-md-2">
                                                    <opt></opt>
                                                    <label>Description</label>
                                                </div>
                                                <div class="col-md-10" ng-bind-html="tariffDetail.Description">                                                   
                                                </div>
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-2">
                                                    <opt></opt>
                                                    <label>Statistical Unit</label>
                                                </div>
                                                <div class="col-md-3">
                                                    {{tariffDetail.StatUnitCode}} - {{tariffDetail.StatUnitDescription}}
                                                </div>
                                                <div class="col-md-2">
                                                    <label>Notes</label>
                                                </div>
                                                <div class="col-md-3">
                                                    <button type="button" ng-click="tariffViewNotesClick(tariffDetail.HSCodeDisplay.Notes)" ng-class="{'btn btn-info btn-sm': tariffDetail.HSCodeDisplay.Notes == '' , 'btn btn-info btn-sm':  tariffDetail.HSCodeDisplay.Notes != ''}" ng-disabled="!tariffDetail.HSCodeDisplay.Notes">
                                                        <span class="fa fa-sticky-note"></span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-2">
                                                    <opt></opt>
                                                    <label>References</label>
                                                </div>
                                                <div class="col-md-3" ng-if="tariffDetail.Reference2">
                                                    {{tariffDetail.Reference2}}<div ng-if="tariffDetail.Reference3"> / {{tariffDetail.Reference3}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" ng-if="dutyTypeId === 163">
                                        <div class="col-md-4">
                                            <div class="row vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Description</label>
                                                </div>
                                                <div class="col-md-6">
                                                    {{tariffDetail.Description}}
                                                </div>
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>Statistical Unit</label>
                                                </div>
                                                <div class="col-md-6">
                                                    {{tariffDetail.StatUnitCode}} - {{tariffDetail.StatUnitDescription}}
                                                </div>
                                            </div>
                                            <div class="row vertical-align">
                                                <div class="col-md-6">
                                                    <opt></opt>
                                                    <label>References</label>
                                                </div>
                                                <div class="col-md-6" ng-if="tariffDetail.Reference2">
                                                    {{tariffDetail.Reference2}}<div ng-if="tariffDetail.Reference3"> / {{tariffDetail.Reference3}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="row vertical-align" ng-if="dutyTypeId === 163">
                                                <div class="col-md-2">
                                                    <label>HS Code</label>
                                                </div>
                                                <div class="col-md-6">
                                                    {{tariffDetail.HSCodeDisplay.HSCode}}
                                                </div>
                                            </div>
                                            <div class="row vertical-align" ng-if="dutyTypeId === 163">
                                                <div class="col-md-2">
                                                    <label>Description</label>
                                                </div>
                                                <div class="col-md-10">
                                                    <div style="max-height: 240px; overflow-y: scroll;overflow-x:hidden;">
                                                        <div class="row vertical-align" ng-repeat="HSCodeDescription in tariffDetail.HSCodeDisplay.HSCodeDescriptionHierarchy">
                                                            <div class="col-md-3"><b>{{HSCodeDescription.HSCode}}</b></div>
                                                            <div class="col-md-9"><div>{{HSCodeDescription.Description}}</div></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <br/>
                                            <div class="row vertical-align">
                                                <div class="col-md-2">
                                                    <label></label>         
                                                </div>
                                                <div class="col-md-10">
                                                    <div class="col-md-3"></div>
                                                    <div class="col-md-8">
                                                        <div class="row vertical-align">
                                                            <div class="col-md-4">
                                                                <div class="GridButton">
                                                                    <center>
                                                                        <button type="button" ng-click="tariffViewNotesClick(tariffDetail.HSCodeDisplay.Notes)" ng-class="{'btn btn-default btn-sm btn-block': tariffDetail.HSCodeDisplay.Notes == '' , 'btn btn-default btn-sm btn-block':  tariffDetail.HSCodeDisplay.Notes != ''}" ng-disabled="!tariffDetail.HSCodeDisplay.Notes">
                                                                        <img style="width:32px;height:32px;" ng-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAbFBMVEX///8AAAAEBASoqKirq6ujo6Ovr6/z8/McHBwnJyf5+flsbGwMDAzGxsYHBwfY2NjPz8/q6upZWVk+Pj4TExMkJCS9vb0xMTF/f391dXXf39+5ubk5OTlRUVGJiYmVlZVlZWVCQkJJSUlgYGAaV1iWAAAEvUlEQVR4nO2b65ajIAyAtXbqrfebvU6nO+//jmsQFCEKUVo755gfW5kV8pkECDb1vFEKSYJtPPcdyjx+ntb2+mcHl8pLiaeW+s8vUQ9yuwyr3/f3Rwv7w43LdBGGi3QJ11dLw7VJuAq2bLClkSAB/0c8YNZR3jg4AAC53JkNTF4IALMM2DVgzxwReN8sDgw3bfN70qqZ5s1fVwAFgeF54vyWRdVcOPRBLuCFuP0WWH/Cqhnmzbk7gAu4tH1FAiO1tXsKmOA0JMBXPtyzI0D/ZSgfZGUMghcDmGPqxQBml34wgBsZAf4ywOBBOAK8EQDr6Eo+HyAaGuCKELwVoLkDOebQBxkB/jKAGxkB/jLA4EE4AgwO4EZGgL8MMHgQjgCDA7iQWTQswHTiDwrA9Q8GEHD9ftANoF/wcf0T9g+FwBkAs//ki3+8H2AmHj0g2sAVQFSqJRJUAP2kAiASuAKYTToSuAIo1gAefZRIdAQg1iA6Qd8gLPpqa4C9F5wAIGuAtQ1cAATYGlBcm7+TdAAgqdUIIgJAV6m5W4V5A4ASboo7KC7oJlqwUTelngDIdCNuyxjA5bHN9pPJPts+Wr6Mn0XRDJvuZV5itxjrAMFNjvJb0yigB3tOon4N4BqrEy1GiyKa9JQO6LYZJT/YXP9JiPoDcI+d/jrAJitGzU7HVRiujifevm0w/YgDCq7UI4gMsCnMf19V/726F26oEzRNNb4nUlJCGSBhz3tY1G9YsKqnm+yFpvyPGn8qAPP/TrW2t9mpZm3I/4pG2jkpvTL97ElZrdk83gZFixFIcwHP/8Rl56QUAuDAnr+qNTuwWN5AWypLQPO/Kv46JqVQYFTU19Rqvc7wF6i1kQ9cSOYhxx/pcFICwPq31fRzApgLO6mXnnnU4o9iAwFwgQuYf1qtGXgBSkN8eV/QCOrxRyAQAI/8M/PQWjOIRJihD7mf5gVoVH+094IAgBIvKABCas2gTvEkHNRsA0g+AroNBEDGZxpSawaKj9xAbQQR56cRCIA9DwGk1gwmIATBXumK5n/kSBQAYGuoMWuoNYPPpdoXy//Ic6EPALYpidloHYk9XOB5yLbMtFNs0D0IKxvIzwkN0mzsPA1rBJUONh6FoOtCVCOQNBTjEQgEAHEplqSe//Hx7FckAcA2oztc2GxG5geytkEJYNyO7SrHy/FsCcoObQlJpM+BpsS7Gs+SoOoAM02kZNMiJZviKVkul3nD0bsaT4sD/KQgdbBOSvOFkSXQoXprfTyVAH9XIHVI2KFQS8vZdxC1tNwL//lifrQBKJuFEcD6YLLgMRJr1lKPepzA0gU5AT8YtxzNwvXXrpwi0VTzQh3A4mVBvUOS+oikSf1+xvhbv6cBQN8sDMTeUTueZ0f1/lx+k+RpBaBtFiaA3Go7eeDdVL/fvwFTcrICUDcLMwB/RbNcoq9o5vHzWwTp6pztzQCNa1YzQB8hjzcCfBwAVvDYTSK7HzCpAM7027yoxgDc6bd0xUcCWHUkjvu5AC/64ZP9OC/66Zc4U5ql4SzYV+zHQc6CpAIIXMozpVn0s2Ckv5wn6y/PlBaCngX7CHmcF/0I9myP/BICgv5X/BD6QPQjOwu6Ul6eKUdB5D92tzjaQfTMVgAAAABJRU5ErkJggg=="> <br/> <b>Legal</b> <br/><b>Notes</b>
                                                                        </button>
                                                                    </center>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-4">
                                                                 <wco-trade-tool-notes
                                                                    is-section = "0"
                                                                    section="tariffDetail.HSCodeDisplay.HSCodeDescriptionHierarchy[0].HSCode"
                                                                    hs-code="tariffDetail.HSCodeDisplay.HSCode"
                                                                    year="2022"
                                                                    notes-type="1"
                                                                    show-text="1"
                                                                    wco-enabled="wcoTradeToolsEnabled"
                                                                    >
                                                            </div>
                                                            <div class="col-md-4">
                                                                <wco-trade-tool-notes
                                                                    is-section = "0"
                                                                    section="tariffDetail.HSCodeDisplay.HSCodeDescriptionHierarchy[0].HSCode"
                                                                    hs-code="tariffDetail.HSCodeDisplay.HSCode"
                                                                    year="2022"
                                                                    notes-type="3"
                                                                    show-text="1"
                                                                    wco-enabled="wcoTradeToolsEnabled"
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <uib-accordion>
                                        <div uib-accordion-group class="panel-custom-directive" is-open="searchAccordian">
                                            <uib-accordion-heading>
                                                <span uib-accordion-header="" ng-class="{'text-muted': isDisabled}" class="ng-binding">Duties</span>
                                            </uib-accordion-heading>
                                            <form name="tarDuties">
                                                <div class="container-fluid">
                                                    <!-- Show All -->
                                                    <div class="row vertical-align">
                                                        <div class="col-md-2">
                                                            <opt></opt>
                                                            <label>Show All</label>
                                                        </div>
                                                        <div class="col-md-2">
                                                            <p class="input-group-sm">
                                                                <input type="checkbox" ng-model="showAll" ng-change="refreshTariff()" />
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div ui-grid="gvwDuties" ui-grid-resize-columns ui-grid-selection ui-grid-edit ui-grid-cellNav ui-grid-row-edit class="gridSmallScreen" ng-if="tariffDetail"></div>
                                                </div>
                                            </form>
                                        </div>
                                    </uib-accordion>
                                    <uib-accordion>
                                        <div uib-accordion-group class="panel-custom-directive" is-open="searchAccordian1">
                                            <uib-accordion-heading>
                                                <span uib-accordion-header="" ng-class="{'text-muted': isDisabled}" class="ng-binding">Prohibited and Restricted Items</span>
                                                    <div ng-if="isProhibited === true" class="pull-left" style="margin-right: 5px;">
                                                        <span class="fa fa-times" style="color: #cb2330;"></span>
                                                    </div>
                                                    <div ng-if="isProhibited === false" class="pull-left" style="margin-right: 5px;">
                                                        <span class="fa fa-exclamation-triangle" style="color: #f57f20; opacity: 0.7;"></span>
                                                    </div>
                                                    <div ng-if="isProhibited === null" class="pull-left" style="margin-right: 5px;">
                                                        <span class="fa fa-check" style="color: #bcd856;"></span>
                                                    </div>
                                            </uib-accordion-heading>
                                            <form name="tarPR">
                                                <div class="container-fluid">
                                                    <div ui-grid="gvwProhibited" ui-grid-resize-columns ui-grid-selection ui-grid-edit ui-grid-cellNav ui-grid-row-edit class="gridSmallSmall" ></div>
                                                </div>
                                            </form>
                                        </div>
                                    </uib-accordion>
	                            </div>
                            </div>
                        </div>
                    `,
                        controller: ($scope, $uibModalInstance: ng.ui.bootstrap.IModalInstanceService) => {
                            $scope.nationalMeasureCode = nationalMeasureCode;
                            $scope.countryId = countryId;
                            $scope.dutyTypeId = dutyTypeId;
                            $scope.simulationDate = simulationDate;
                            $scope.isTarrifSearch = isTarrifSearch;

                            $scope.Type = dutyTypeCode;

                            $scope.gvwDuties = this.gvwDuties;
                            $scope.gvwProhibited = this.gvwProhibited;
                            $scope.gvwExclusion = this.gvwExclusion;
                            $scope.tariffDetail = null;

                            $scope.IsLoading = true;
                            $scope.searchAccordian = false;
                            $scope.searchAccordian1 = false;
                            $scope.isProhibited = null;
                            $scope.wcoTradeToolsEnabled = false;


                            $scope.getDetailPDF = () => {
                                this.bsLoadingOverlayService.wrap({
                                    referenceId: 'tariffLoading'
                                },
                                    () => {
                
                                        this.hsCodeService.getDetailPDF(countryId,dutyTypeId,simulationDate.format("YYYYMMDDTHH:mm"),nationalMeasureCode,$scope.showAll,true).then(() => {
                
                                        }, (errorResponse) => {
                                            this.generalService.displayMessageHandler(<interfaces.applicationcore.IMessageHandler>errorResponse.data);
                                        });
                
                                    });
                            }

                            $scope.prohibitedAndRestricted_Click = (id: number) => {
                                this.prohibitedAndRestricted_Click(id);
                            }

                            $scope.tariffViewNotesClick = (notes: string) => {
                                this.DisplayTariffNotes(notes);
                            }

                            $scope.tariffDutyViewAdditional = (additionalDescription: string) => {
                                this.DisplayAdditional(additionalDescription);
                            }

                            $scope.viewRestrictionDetail = (restrictionId: number) => {
                                if (this.$state.current.name === "auth.ProductTariff.Update"){
                                    this.$state.go("auth.ProductTariff.Update.RestrictionDetail", { parId: restrictionId });
                                }
                                else if(!$scope.isTarrifSearch) {
                                    this.$state.go("auth.TariffBrowse.RestrictionDetail", { parId: restrictionId });
                                } else {
                                    this.$state.go("auth.TariffSearch.RestrictionDetail", { parId: restrictionId });
                                }
                                
                                $uibModalInstance.close();
                            }

                            $scope.DisplayExclusions = (ExclusionList: Array<interfaces.tariff.INationalMeasureExclusions>) => {
                                this.gvwExclusion.data = ExclusionList;
                                this.DisplayExclusions();
                            }

                            $scope.refreshTariff = () => {
                                $scope.showAll = !$scope.showAll;
                                this.refreshTariff($scope.showAll, $scope);
                            }

                            this.bsLoadingOverlayService.wrap({
                                referenceId: 'tariffLoading'
                            },
                                () => {
                                    return this.hsCodeService.getDetail().get({
                                        countryId: countryId,
                                        codeType: dutyTypeId,
                                        simulationDate:  simulationDate.format("YYYYMMDDTHH:mm"),
                                        code: nationalMeasureCode,
                                    }, (result: interfaces.tariff.INationalMeasureCodeDetail) => {

                                        $scope.IsLoading = false;

                                        $scope.tariffDetail = result;

                                        $scope.gvwDuties.data = $scope.tariffDetail.DutiesList;
                                        $scope.gvwProhibited.data = $scope.tariffDetail.ProhibitedList;
                                        $scope.gvwExclusion.data = $scope.tariffDetail.exclusionList;

                                        var promises: ng.IPromise<any>[] = [];
                                        var verifyWCOTradeToolsEnabled = this.wcoTradeToolsService.VerifyWCOTradeToolsEnabled().get({ }, (result: interfaces.tariff.VerifyTradeTools) => {
                                            
                                            $scope.wcoTradeToolsEnabled = result.isWCOTradeToolsEnabled;
                                        }).$promise;                
                        
                                      
                                        promises.push(verifyWCOTradeToolsEnabled);
                        
                                        this.bsLoadingOverlayService.wrap({
                                            referenceId: 'tariff.lookup.search'
                                        }, () => {
                                            return this.$q.all(promises);
                                        });

                                        //Check if there are any restrictions
                                        _.forEach($scope.tariffDetail.ProhibitedList, (restrictedItem) => {
                                            if($scope.isProhibited === true)
                                            {
                                                return;
                                            }

                                            if(restrictedItem.IsProhibited === true)
                                            {
                                                $scope.isProhibited = true;
                                                return;
                                            }

                                            if(restrictedItem.IsProhibited === false)
                                            {
                                                $scope.isProhibited = false;
                                                return;
                                            }
                                        });

                                    }, (errorResponse) => {
                                        $scope.IsLoading = false;

                                        if (errorResponse.data.Messages) {
                                            this.messages = [];
                                        }

                                        angular.forEach(errorResponse.data.Messages, (o) => {
                                            angular.forEach(o.MessageItems, (n) => {
                                                this.messages.push(n);
                                            });
                                        });
                                    }).$promise;
                                });

                            $scope.ok = () => {
                                $uibModalInstance.close();
                            }

                            $scope.cancel = () => {
                                $uibModalInstance.close();
                            }
                        },
                        size: "xlg",
                        resolve: {
                        }
                    });
            }

            DisplayTariffNotes(Notes: string) {
                //Get delivery status
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="modal-title">HS Code Notes</h3>
                            </div>
                            <div class="modal-body" id="modal-body">
                                <p ng-bind-html="tariffNotesCtrl.Notes"></p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary"  ng-click="tariffNotesCtrl.ok()">Ok</button>
                            </div>
                        </div>
                    `,
                    controller: class tariffNotesCtrl {
                        Notes: string;
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, $sce) {
                            this.Notes = $sce.trustAsHtml(Notes);
                        }
                        ok() {
                            this.$uibModalInstance.close();
                        }
                    },
                    controllerAs: "tariffNotesCtrl",
                    size: "lg",
                    resolve: {
                    }
                }).result;
            }

            refreshTariff(showAll: boolean, $scope: any) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'tariffLoading'
                },
                    () => {
                        return this.hsCodeService.getDetail().get({
                            countryId: $scope.countryId,
                            codeType: $scope.dutyTypeId,
                            simulationDate: $scope.simulationDate.format("YYYYMMDDTHH:mm"),
                            code: $scope.nationalMeasureCode,
                            showAll: showAll,
                        }, (result: interfaces.tariff.INationalMeasureCodeDetail) => {

                            $scope.IsLoading = false;

                            $scope.tariffDetail = result;

                            $scope.gvwDuties.data = $scope.tariffDetail.DutiesList;
                            $scope.gvwProhibited.data = $scope.tariffDetail.ProhibitedList;
                        }, (errorResponse) => {
                            $scope.IsLoading = false;

                            if (errorResponse.data.Messages) {
                                this.messages = [];
                            }

                            angular.forEach(errorResponse.data.Messages, (o) => {
                                angular.forEach(o.MessageItems, (n) => {
                                    this.messages.push(n);
                                });
                            });
                        }).$promise;
                    });
            }

            DisplayAdditional(additionalDescription: string) {
                //Get delivery status
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content">
                            <div class="modal-header">
                                <h3 class="modal-title" id="modal-title">Tariff Additional Description</h3>
                            </div>
                            <div class="modal-body" id="modal-body">
                                <p ng-bind-html="tariffAdditionalCtrl.additionalDescription"></p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary"  ng-click="tariffAdditionalCtrl.ok()">Ok</button>
                            </div>
                        </div>
                    `,
                    controller: class tariffAdditionalCtrl {
                        additionalDescription: string;
                        constructor($scope, private $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, $sce) {
                            this.additionalDescription = $sce.trustAsHtml(additionalDescription);
                        }
                        ok() {
                            this.$uibModalInstance.close();
                        }
                    },
                    controllerAs: "tariffAdditionalCtrl",
                    size: "md",
                    resolve: {
                    }
                }).result;
            }

            DisplayExclusions() {
                return this.$uibModal.open({
                    animation: true,
                    template: `
                        <div class="modal-content" >
                            <form name="tariffExclusions">
                                <div class="gts-padding">
                                    <fieldset id="exclusions">
                                    <legend>
                                       Exclusions
                                    </legend>
                                            <div ui-grid="gvwExclusion" ui-grid-resize-columns ui-grid-selection ui-grid-edit ui-grid-cellNav ui-grid-row-edit class="gridSmall"></div>
                                            <div class="gts-padding pull-right">                                               
                                                    <button type="button" class="btn btn-primary"  ng-click="ok()">Ok</button>                                                   
                                            </div>                                       
                                    </fieldset>
                                </div>
                            </form>
                        </div>
                    `
                    ,
                    controller: ($scope, $uibModalInstance: angular.ui.bootstrap.IModalInstanceService, $sce) => {
                        $scope.gvwExclusion = this.gvwExclusion;

                        $scope.ok = () => {
                            $uibModalInstance.close();
                        }
                    },
                    size: "md",
                    resolve: {
                    }
                }).result;
            }

            //Duties Grid
            apiDutiesList: uiGrid.IGridApi;
            gvwDuties: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableCellEditOnFocus: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: false,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerDutiesGridApi(gridApi); },
                columnDefs: [{
                    name: "COUNTRYGROUPCODE",
                    displayName: "Country Group",
                    field: "",
                    type: "string",
                    width: 150,
                    cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.CountryGroupCode" data-toggle="tooltip" data-placement="top" title="{{row.entity.CountryGroupCode}} - {{row.entity.CountryGroupDescription}}">{{row.entity.CountryGroupCode}} - {{row.entity.CountryGroupDescription}}</div>`,
                }, {
                    name: "TAXTYPE",
                    displayName: "Tax Type",
                    field: "",
                    type: "string",
                    width: 190,
                    cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.TaxTypeCode">{{row.entity.TaxTypeCode}} - {{row.entity.TaxTypeDescription}}</div>`,
                }, {
                    name: "FORMULA",
                    displayName: "Formula",
                    field: "Formula",
                    type: "string",
                    width: 150,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                }, {
                    name: "TYPE",
                    displayName: "Type",
                    field: "Type",
                    type: "string",
                    width: 75,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                }, {
                    name: "LINKEDCODE",
                    displayName: "Linked Code",
                    field: "",
                    type: "string",
                    width: 125,
                    cellTemplate: `<div class="ui-grid-cell-contents" >{{row.entity.LinkedCode}}</div>`,
                }, {
                    name: "PREFERENCECODE",
                    displayName: "Preference Code",
                    field: "",
                    type: "string",
                    width: 125,
                    cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.PreferenceCode">{{row.entity.PreferenceCode}} - {{row.entity.PreferenceCodeDescription}}</div>`,
                }, {
                    name: "STARTDATE",
                    displayName: "Start Date",
                    field: "StartDate",
                    width: 90,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: "YYYY/MM/DD"}}</div>`,
                }, {
                    name: "ENDDATE",
                    displayName: "End Date",
                    field: "EndDate",
                    width: 85,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: "YYYY/MM/DD"}}</div>`,
                }, {
                    name: "EXCLUSIONS",
                    displayName: "Exclusions",
                    field: "",
                    enableHiding: false,
                    width: 80,
                    enableSorting: false,
                    enableColumnMenu: false,
                    cellTemplate: ` <div class="ui-grid-cell-contents" ng-click="grid.appScope.DisplayExclusions(row.entity.ExclusionList)" ng-if="row.entity.ExclusionList.length > 0">
                                            <span class="fa fa-eye"></span>
                                        </div>`,
                },
                {
                    name: "Additional",
                    displayName: "",
                    field: "",
                    width: 30,
                    enableSorting: false,
                    enableHiding: false,
                    enableColumnMenu: false,
                    cellTemplate: ` <div class="ui-grid-cell-contents" ng-click="grid.appScope.tariffDutyViewAdditional(row.entity.AdditionalDescription)" ng-if="row.entity.AdditionalDescription">
                                        <span class="fa fa-sticky-note"></span>
                                    </div>`,
                }]
            };

            registerDutiesGridApi(gridApi: uiGrid.IGridApi) {
                this.apiDutiesList = gridApi;
            }

            //Prohibited and Restricted Items
            apiProhibitedList: uiGrid.IGridApi;
            gvwProhibited: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableCellEditOnFocus: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: false,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerProhibitedGridApi(gridApi); },
                columnDefs: [{
                    name: "COUNTRYCODE",
                    displayName: "Country Code",
                    field: "",
                    type: "string",
                    width: 110,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{row.entity.CountryCode}}</div>`,
                }, {
                    name: "COUNTRYGROUP",
                    displayName: "Country Group",
                    field: "",
                    type: "string",
                    width: 150,
                    cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.CountryGroupCode">{{row.entity.CountryGroupCode}} - {{row.entity.CountryGroupDescription}}</div>`,
                }, {
                    name: "RESTRICTIONCODE",
                    displayName: "Restriction Code",
                    field: "RestrictionCode",
                    type: "string",
                    width: 125,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                }, {
                    name: "RESTRICTIONTEXT",
                    displayName: "Restriction Text",
                    field: "RestrictionText",
                    type: "string",
                    width: 160,
                    cellTemplate: `<div class="ui-grid-cell-contents" data-toggle="tooltip" data-placement="top" title="{{MODEL_COL_FIELD}}">{{MODEL_COL_FIELD}}</div>`,
                }, {
                    name: "ISPROHIBITED",
                    displayName: "Is Prohibited",
                    field: "IsProhibited",
                    width: 100,
                    cellTemplate: `
                        <div class="ui-grid-cell-contents">
                            <div ng-if="row.entity.IsProhibited">
                                <p style="color: #cb2330;">Prohibited</p>
                            </div>
                            <div ng-if="!row.entity.IsProhibited">
                                <p style="color: #f57f20;">Restricted</p>
                            </div>
                        </div>`,
                }, {
                    name: "TYPE",
                    displayName: "Type",
                    field: "Type",
                    type: "string",
                    width: 75,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD}}</div>`,
                }, {
                    name: "STARTDATE",
                    displayName: "Start Date",
                    field: "StartDate",
                    width: 100,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD'}}</div>`,
                }, {
                    name: "ENDDATE",
                    displayName: "End Date",
                    field: "EndDate",
                    width: 100,
                    cellTemplate: `<div class="ui-grid-cell-contents">{{MODEL_COL_FIELD | momentDateFilter: 'YYYY/MM/DD'}}</div>`,
                }, {
                    name: "DETAIL",
                    displayName: "Detail",
                    field: "Detail",
                    enableFiltering: false,
                    enableColumnResizing: false,
                    cellTemplate: `
                        <div class="GridButton">
                            <center>
                                <button ng-if="row.entity.Detail" type="button" class="btn btn-default btn-sm" ng-click="grid.appScope.viewRestrictionDetail(row.entity.RestrictionId)">
                                    <span class="fa fa-eye"></span>
                                </button>
                            </center>
                        </div>`,
                    width: 60
                }, ]
            };

            registerProhibitedGridApi(gridApi: uiGrid.IGridApi) {
                this.apiProhibitedList = gridApi;
            }

            //Exclusions
            apiExclusionList: uiGrid.IGridApi;
            gvwExclusion: uiGrid.IGridOptions = {
                data: [],
                enableFiltering: false,
                useExternalFiltering: false,
                enableCellEdit: false,
                useExternalSorting: false,
                multiSelect: false,
                enableColumnResizing: true,
                enableFullRowSelection: true,
                useExternalPagination: false,
                enableRowHeaderSelection: false,
                enableCellEditOnFocus: false,
                enableHorizontalScrollbar: 2,
                rowEditWaitInterval: -1,
                cellEditableCondition: false,
                showGridFooter: true,
                onRegisterApi: (gridApi) => { this.registerExclusionGridApi(gridApi); },
                columnDefs: [{
                    name: "COUNTRYGROUPCODE",
                    displayName: "Country",
                    field: "",
                    type: "string",
                    width: 300 ,
                    cellTemplate: `<div class="ui-grid-cell-contents" ng-if="row.entity.CountryCode">{{row.entity.CountryCode}} - {{row.entity.CountryDescription}}</div>`,
                }, ]
            };

            registerExclusionGridApi(gridApi: uiGrid.IGridApi) {
                this.apiExclusionList = gridApi;
            }

            prohibitedAndRestricted_Click(id: number) {
                this.bsLoadingOverlayService.wrap({
                    referenceId: 'tariffLoading'
                }, () => {
                    return this.menuService.getGTSConnectMenuItem(585).get((result: interfaces.applicationcore.IMenu) => {
                        if (result.url) {
                            result.url += "?Id=" + id;
                            var url = this.$state.href("auth.IFrame", { url: result.url });
                            window.open(url, '_blank');
                        }
                    }).$promise;
                });
            }

            static factory(): ng.IDirectiveFactory {
                const directive = (generalService, $uibModal, hsCodeService, $state,
                    bsLoadingOverlayService, menuService,wcoTradeToolsService,$q) => new tariffDetailDirective(generalService, $uibModal, hsCodeService, $state, bsLoadingOverlayService, menuService,wcoTradeToolsService,$q);
                directive.$inject = ["generalService", "$uibModal", "hsCodeService", "$state", "bsLoadingOverlayService", "menuService","wcoTradeToolsService","$q"];

                return directive;
            }
        }

        angular.module("app").directive("gtsTariffDetail", tariffDetailDirective.factory());
    }
}
